// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"5602792c","96":"31d6cfe0","214":"81dc7f52","290":"c62d7ea5","408":"33df3500","686":"0b74897a"}[chunkId] + ".chunk.css";
};